import Box from '@mui/material/Box'

import Button from '@mui/material/Button'

import Typography from '@mui/material/Typography'



import { ConfirmationModalIcon } from '@/shared/components/confirmation/ConfirmationModalIcon'

import {

  ConfirmationModalLayout,

  ConfirmationModalShell,

} from '@/shared/components/confirmation/ConfirmationModalShell'

import {

  confirmationBodySx,

  confirmationHeadlineSx,

  confirmationPrimaryButtonSx,

  confirmationSecondaryButtonSx,

} from '@/shared/components/confirmation/confirmationModalStyles'



interface Props {

  open: boolean

  onClose: () => void

  onTopUp: () => void

}



/** AC-9–11 — Tremendous account insufficient before reactivation. */

export function InsufficientBudgetModal({ open, onClose, onTopUp }: Readonly<Props>) {

  return (

    <ConfirmationModalShell

      open={open}

      onClose={onClose}

      dialogTestId="insufficient-budget-dialog"

      ariaLabelledBy="insufficient-budget-headline"

      ariaDescribedBy="insufficient-budget-body"

    >

      <ConfirmationModalLayout>

        <ConfirmationModalIcon variant="caution" />



        <Box

          id="insufficient-budget-body"

          sx={{

            width: '100%',

            px: '24px',

            pt: '12px',

            display: 'flex',

            flexDirection: 'column',

            alignItems: 'center',

            gap: '12px',

          }}

        >

          <Typography id="insufficient-budget-headline" component="h2" sx={confirmationHeadlineSx}>

            Insufficient Budget

          </Typography>

          <Typography sx={{ ...confirmationBodySx, maxWidth: 388 }}>

            Your account does not have enough balance to reactivate this instrument. Please top up

            your account to continue.

          </Typography>

        </Box>



        <Box

          sx={{

            display: 'flex',

            flexDirection: 'row',

            alignItems: 'center',

            justifyContent: 'center',

            gap: '12px',

            width: '100%',

            px: 3,

            py: 3,

          }}

        >

          <Button

            variant="outlined"

            onClick={onClose}

            data-testid="insufficient-budget-cancel"

            sx={confirmationSecondaryButtonSx}

          >

            Cancel

          </Button>

          <Button

            variant="contained"

            onClick={onTopUp}

            data-testid="insufficient-budget-top-up"

            sx={confirmationPrimaryButtonSx}

          >

            Top Up Account

          </Button>

        </Box>

      </ConfirmationModalLayout>

    </ConfirmationModalShell>

  )

}

